/**
 * 常量集合 提供给actions和reduces使用
 * @type {string}
 */

export const set_form_data = 'set_form_data';
export const del_form_data = 'del_form_data';
export const submit_verify = 'submit_verify';
export const del_form_store = 'del_form_store';

export const reset_form = 'reset_form';


